import { gt } from '~/lib/gt'

import { Button } from '../Button/Button'

import styles from './VerifyAccountModal.module.css'

interface VerifyAccountModalViewProps {
  handleClose: () => void
}

const VerifyAccountModalView = ({ handleClose }: VerifyAccountModalViewProps) => {
  return (
    <div className={styles.verifyAccountModal}>
      <h6 className={styles.h6}>{gt.tp('CheckYourEmailModal', 'Thank you for joining us!')}</h6>
      <h3 className={styles.h3}>{gt.tp('CheckYourEmailModal', 'Verify your account with a confirmation link')}</h3>
      <h6 className={styles.h6}>{gt.tp('CheckYourEmailModal', "We've sent a confirmation link to your email address.")}</h6>
      <Button className={styles.submitButton} onClick={handleClose}>
        {gt.tp('ForgotPasswordModal', 'Okay, close')}
      </Button>
    </div>
  )
}

export default VerifyAccountModalView
